<template>
  <section class="faq-section">
    <b-container class="position-relative">
      <b-row>
        <b-col sm="12">
          <h4 class="main-title-faq">{{$t('faq')}}</h4>
          <div class="accordion" role="tablist">
            <div no-body class="accordion-body" v-for="(item, index) in accordions" :key="index">
              <div  header-tag="header" class="accordion-header" role="tab">
                <b-button class="accordion-btn" block @click="toggleAccordion(index)">
                  <span class="btn-title">{{ $t(item.title) }}</span>
                  <span class="btn-icon" v-if="item.isOpen">-</span>
                  <span class="btn-icon" v-else>+</span>
                </b-button>
              </div>
              <b-collapse :id="'accordion-' + index" v-model="item.isOpen" role="tabpanel">
                <b-card-body>
                  <p class="text">{{ $t( item.contentText ) }}</p>
                  <ol v-if="item.contentList">
                    <li v-for="list in $t(item.contentList)" :key="list">{{ list }}</li>
                  </ol>
                  <div class="img-container">
                    <img v-if="$i18n.locale === 'en'" class="slider-img" :src="require(`../../assets/img/new-content/${item.imgNameEng}`)" alt="Image">
                    <img v-else-if="$i18n.locale === 'uk'" class="slider-img" :src="require(`../../assets/img/new-content/${item.imgNameUa}`)" alt="Image">
                    <img v-else class="slider-img" :src="require(`../../assets/img/new-content/${item.imgNameEng}`)" alt="Image">
                  </div>
                  <p class="text" style="margin-top: 40px">{{$t(item.infoText)}}</p>
                  <p class="text" v-if="item.dataText" style="margin-top: 40px">{{ $t(item.dataText) }}</p>
                  <p class="text faq-email" v-if="item.emailText">
                    {{ $t(item.emailText) }}
                    <a href="mailto:info@grexy.co">info@grexy.co</a>
                  </p>
                </b-card-body>
              </b-collapse>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>
<script>

export default {
  data () {
    return {
      accordions: [
        {
          title: 'how_to_delete_your_profile_from_the_app',
          contentText: 'faq_1',
          contentList: 'faq_list_1',
          infoText: 'remember_text',
          imgNameEng: 'delete-profile-eng.png',
          imgNameUa: 'delete-profile-ua.png',
          dataText: 'faq_data_text',
          emailText: 'faq_email_text',
          isOpen: true
        }
      ]
    }
  },
  methods: {
    toggleAccordion (index) {
      this.accordions[index].isOpen = !this.accordions[index].isOpen
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/sass/app.scss";

.faq-section{
  padding-top: 160px;
  padding-bottom: 80px;
  .main-title-faq{
    color:  #30394B;
    font-family: $main-font;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 48px;
    padding-bottom: 8px;
    margin-bottom: 8px;
    border-bottom: 1px solid #A7B1B6;
  }
  .accordion{
    .accordion-header{
      border-bottom: 1px solid #DADFE2;
      .accordion-btn {
        display: inline-flex;
        justify-content: space-between;
        align-items: center;
        background: transparent;
        border: none;
        font-family: $main-font;

        border-radius: 0;
        &:focus,
        &:active{
          box-shadow: none !important;
          border: none !important;
          background: transparent !important;
        }
        .btn-title{
          color: #30394B;
          font-size: 18px;
          line-height: 140%
        }
        .btn-icon{
          font-size: 18px;
          line-height: 140%;
          color: #5C5EE8;
        }
      }
    }
    .text, li{
      font-family: $main-font;
      font-size: 18px;
      font-weight: 300;
      line-height: 25.2px;
      text-align: left;
    }
    .text{
      margin-bottom: 5px;
    }
    .faq-email a{
      color: #5C5EE8;
      text-decoration: underline;
      word-break: break-word;
    }
    ol{
      margin-top: 23px;
      padding-left: 30px;
      li{
        margin-bottom: 5px;
      }
    }
    .img-container{
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      margin-top: 23px;
      img{
        width: 100%;
      }
    }
  }
}
</style>
